exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\n\n/* purgecss end ignore */", "", {"version":3,"sources":["/app/<no source>"],"names":[],"mappings":"AAAA,2BAAA;;AAAA,yBAAA","file":"Summary.css","sourcesContent":[null],"sourceRoot":""}]);

// exports
